import type { ReactNode } from "react";
import type { Prospect } from "@/lib/types";

function Field({ label, children }: { label: string; children: ReactNode }) {
  if (!children) return null;
  return (
    <div className="mt-3">
      <div className="text-[10px] uppercase tracking-wide text-neutral-400">{label}</div>
      <p className="mt-0.5 whitespace-pre-line text-sm text-neutral-700">{children}</p>
    </div>
  );
}

export function LeadInfoPanel({ prospect: p }: { prospect: Prospect }) {
  return (
    <div className="space-y-4">
      <section className="aurora-tile-white p-5">
        <div className="text-[10px] uppercase tracking-wide text-neutral-400">
          Coordonnées & entreprise
        </div>
        <div className="mt-2 space-y-1 text-sm text-neutral-700">
          <div>✉️ {p.email}</div>
          <div className="font-medium">
            🏢 <span>{p.company_name ?? "—"}</span>
            {p.company_size ? ` · ${p.company_size}` : ""}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {p.industry && (
              <span className="inline-flex rounded bg-aurora-gray px-1.5 py-0.5 text-xs text-aurora-teal">
                {p.industry}
              </span>
            )}
            {(p.city || p.country) && (
              <span className="text-xs text-neutral-500">
                {[p.city, p.country].filter(Boolean).join(", ")}
              </span>
            )}
          </div>
          <div className="flex gap-3 pt-1 text-xs">
            {p.company_website && (
              <a
                className="text-aurora-bright-blue hover:underline"
                href={p.company_website}
                target="_blank"
                rel="noreferrer"
              >
                Site web
              </a>
            )}
            {p.linkedin_url && (
              <a
                className="text-aurora-bright-blue hover:underline"
                href={p.linkedin_url}
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
            )}
          </div>
        </div>
      </section>

      <section className="aurora-tile-white p-5">
        <div className="text-[10px] uppercase tracking-wide text-neutral-400">
          Synthèse IA (qualification)
        </div>
        <Field label="Résumé entreprise">{p.company_summary}</Field>
        <Field label="Résumé contact">{p.contact_summary}</Field>
        <Field label="Besoins IA détectés">{p.ai_needs_summary}</Field>
        {p.angles_pitched && p.angles_pitched.length > 0 && (
          <div className="mt-3">
            <div className="text-[10px] uppercase tracking-wide text-neutral-400">
              Angles pitchés
            </div>
            <div className="mt-1 flex flex-wrap gap-1.5">
              {p.angles_pitched.map((a) => (
                <span
                  key={a}
                  className="rounded bg-[color-mix(in_srgb,var(--aurora-color-border-focus)_10%,transparent)] px-2 py-0.5 text-xs text-aurora-bright-blue"
                >
                  {a}
                </span>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
